import React, { FC } from 'react';
import { LegalText } from './index';

export interface Props {
  legalText: LegalText;
}

const FooterBottom: FC<Props> = ({ legalText }) => {
  const { textColor, textSize, textStyle, text } = legalText;
  return (
      <div className="pt-28">
        <p
          className="text-14"
          data-ffid={`lbl-btm-footer`}
          style={{ color: textColor, fontSize: textSize, fontWeight: textStyle }}
        >
          {text}
        </p>
      </div>
  );
};

export default FooterBottom;
